import { useSharedColumnBuilder } from "hooks/useSharedColumnBuilder";

type Props = {
  viewOnly: boolean;
  editMode: boolean;
  checkIfRecordBeingBusy?: (record: any) => boolean;
  updateRecord?: (data: any, record: any) => void;
  handlePersonImageClick?: (record: any) => void;
};

export const useSeasonStaffColumns = ({
  viewOnly,
  editMode,
  checkIfRecordBeingBusy,
  updateRecord,
  handlePersonImageClick,
}: Props) => {
  const { createStaffNameColumn, createPersonStatusColumn, createSeasonStaffRoleColumn } = useSharedColumnBuilder();

  const checkIfReadonly = () => !editMode || viewOnly;
  const checkIfDisabled = (record: any) => checkIfRecordBeingBusy?.(record) ?? false;

  return [
    createStaffNameColumn({ withSorter: true, handlePersonImageClick }),
    createPersonStatusColumn(),
    createSeasonStaffRoleColumn({
      readonly: checkIfReadonly,
      disabled: checkIfDisabled,
      onChange: (value, record) => {
        record.role = value;
        updateRecord?.({ role: value }, record);
      },
    }),
  ];
};
